export default {
  text: 'By using this website you agree to our',
  cookie_policy: 'Cookie Policy.',
  buttons: {
    accept: 'Accept',
    reject: 'Reject',
  },
};
